import React from 'react';
import Relay from 'react-relay/classic';
import PropTypes from 'prop-types';

import get from 'lodash.get';
import { SAVE_ITEM_TO_FOLDER_FLOW } from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';
import userHelper from '../../../global/core/commonjs/userHelper';
import folderTracking from '../../../favorites/shared/folderTracking.es';

import FolderWrapperWrapper from '../../../global/components/FolderWrapperWrapper';

import styles from './RelatedFolderItem-style.scss';

class RelatedFolderItem extends React.Component {
    constructor(props) {
        super(props);

        this.authModalShow = this.authModalShow.bind(this);
    }

    authModalShow(showFolderModal) {
        const { gridType, title, image } = this.props;
        const item = {
            title,
            firstPhotoWebPath: image,
        };

        userHelper
            .checkLogin(
                {
                    label: `save item - product page - ${gridType}`,
                },
                SAVE_ITEM_TO_FOLDER_FLOW,
                false,
                { item }
            )
            .then(showFolderModal);
    }

    render() {
        const {
            viewer,
            item,
            itemId,
            userId,
            userIds,
            selectedItemIds,
            gridType,
            loadPortfolioData,
            shouldFillInFolder,
            onAddItemSuccess,
        } = this.props;

        const pdpFolderItemRelayVariables = {
            loadPortfolioData,
            userId,
            userIds,
            selectedItemIds,
            shouldFillInFolder,
            singlePortfolioItem: true,
        };
        return (
            <div className={styles.pdpFolderItem} data-tn="item-save-to-folder">
                <FolderWrapperWrapper
                    viewer={viewer}
                    primaryItemPk={itemId}
                    {...pdpFolderItemRelayVariables}
                    selectedItemTitles={[get(item, 'title')]}
                    selectedItemImages={[get(item, 'firstPhotoWebPath')]}
                    onAddItemSuccess={onAddItemSuccess}
                    // tracking
                    trackingHooks={folderTracking}
                    authModalTrackingLabel={`save item - product page - ${gridType}`}
                />
            </div>
        );
    }
}

RelatedFolderItem.propTypes = {
    selectedItemIds: PropTypes.array.isRequired,
    shouldFillInFolder: PropTypes.bool.isRequired,
    gridType: PropTypes.string.isRequired,
    title: PropTypes.string,
    image: PropTypes.string,
    userId: PropTypes.string,
    userIds: PropTypes.arrayOf(PropTypes.string),
    itemId: PropTypes.string,
    loadPortfolioData: PropTypes.bool.isRequired,
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        firstPhotoWebPath: PropTypes.string.isRequired,
    }),
    viewer: PropTypes.object,
    onAddItemSuccess: PropTypes.func,
};

module.exports = Relay.createContainer(RelatedFolderItem, {
    initialVariables: {
        userId: null,
        userIds: [],
        selectedItemIds: [],
        loadPortfolioData: false,
        shouldFillInFolder: false,
    },
    fragments: {
        viewer: params => Relay.QL`
                fragment on Viewer {
                    ${FolderWrapperWrapper.getFragment('viewer', params)}
                }
            `,
        item: () => Relay.QL`
                fragment on Item {
                    title
                    firstPhotoWebPath(size: thumb)
                }
            `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Favorites/RelatedFolderItem.jsx